import { getApiBaseUrl } from "src/utils/base-url.util"

const hostname = window.location.hostname

export const BASE_API_V2_URL = `${getApiBaseUrl()}/`


export const BASE_API_URL =
  hostname === 'localhost'
    ? 'http://localhost:4000/api/' // Local API
    : `https://${hostname.replace('journey', 'app-api')}/api/`

export const MAIN_APP_URL =
  hostname === 'localhost'
    ? 'https://app-dev.trackgood.io/' // Dev API
    : `https://${hostname.replace('journey', 'app')}/`
